import { render, staticRenderFns } from "./workshop-feedback-modal.vue?vue&type=template&id=6a20e191&scoped=true"
import script from "./workshop-feedback-modal.vue?vue&type=script&lang=js"
export * from "./workshop-feedback-modal.vue?vue&type=script&lang=js"
import style0 from "./workshop-feedback-modal.vue?vue&type=style&index=0&id=6a20e191&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a20e191",
  null
  
)

export default component.exports